import { PublicClientApplication } from "@azure/msal-browser";

let _instance: PublicClientApplication | null = null;

export const setMsalInstance = (instance: PublicClientApplication): void => {
  _instance = instance;
};

export const getMsalInstance = (): PublicClientApplication | null => _instance;

export const clearMsalCache = (): void => {
  _instance?.clearCache();
};
